import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=edd87e26&"
import script from "./SSO.vue?vue&type=script&lang=ts&"
export * from "./SSO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports